import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const ToastStack = styled.div`
  position: fixed;
  top: 74px;
  right: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
`;

const ToastCard = styled.div`
  width: min(360px, calc(100vw - 24px));
  background: #ffffff;
  border: 1px solid #dbe5f2;
  border-left: 4px solid #1e3a5f;
  border-radius: 10px;
  box-shadow: 0 14px 40px rgba(15, 23, 42, 0.16);
  padding: 10px 12px;
  pointer-events: auto;
`;

const ToastTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #1e3a5f;
  margin-bottom: 4px;
`;

const ToastBody = styled.div`
  font-size: 12.5px;
  color: #334155;
  line-height: 1.45;
`;

const ToastActions = styled.div`
  margin-top: 8px;
  display: flex;
  justify-content: flex-end;
`;

const OpenBtn = styled.button`
  border: none;
  background: #1e3a5f;
  color: #fff;
  font-size: 11.5px;
  font-weight: 600;
  border-radius: 6px;
  padding: 5px 9px;
  cursor: pointer;
  &:hover { background: #14294a; }
`;

let seed = 1;

export default function TeamworkLiveToast() {
  const [toasts, setToasts] = useState([]);

  useEffect(() => {
    const onAlert = (event) => {
      const detail = event?.detail || {};
      const id = seed++;
      const entry = {
        id,
        title: detail.title || 'New Teamwork Message',
        body: detail.body || 'You received a new teamwork message.',
        link: detail.link || '/admin/teamwork',
      };

      setToasts((prev) => [...prev.slice(-2), entry]);

      window.setTimeout(() => {
        setToasts((prev) => prev.filter((item) => item.id !== id));
      }, 5500);
    };

    window.addEventListener('ka-teamwork-live-alert', onAlert);
    return () => window.removeEventListener('ka-teamwork-live-alert', onAlert);
  }, []);

  if (toasts.length === 0) return null;

  return (
    <ToastStack>
      {toasts.map((toast) => (
        <ToastCard key={toast.id}>
          <ToastTitle>{toast.title}</ToastTitle>
          <ToastBody>{toast.body}</ToastBody>
          <ToastActions>
            <OpenBtn type="button" onClick={() => window.open(toast.link, '_blank')}>Open</OpenBtn>
          </ToastActions>
        </ToastCard>
      ))}
    </ToastStack>
  );
}
